import { DPHSettings } from '@features/dph';
import { useOutletContext } from 'react-router';

interface TenantContextType {
  tenantId: string;
  tenant: {
    tenantId: string;
    name: string;
  };
}

/**
 * Data Processing Hours wrapper component
 * Gets tenantId from outlet context and passes to DPHSettings
 */
export const DataProcessingHours = () => {
  const { tenantId } = useOutletContext<TenantContextType>();

  return <DPHSettings tenantId={tenantId} />;
};
